import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import classNames from 'classnames/bind';
import Link from "../../../../Link";
import Scrollbar from "../../../../Scrollbar";
import Search from "../../../../Search";
import Title from "../../../../Title";
import { defaultPropArray, defaultPropObject } from "../../../../constants";
import { useMediaQuery } from "../../../../hooks";
import { ArrowLeft, ChevronNormalRight, CloseLinear } from "../../../../icons";
import { Markup } from "../../../../internal/Markup";
import { TextBase } from "../../../../internal/TextBase";
import noop from "../../../../utils/noop";
import { SearchLink } from '../SearchLink';
import { SearchLoader } from '../SearchLoader';
import { SearchNotFound } from '../SearchNotFound';
import { SearchResults } from '../SearchResults';
import { SearchSubMenuItems } from '../SearchSubMenuItems';
import { Icon } from './components/Icon';
import { Menu } from './components/Menu';
import styles from './MobileMenuCanary.css';
var cx = classNames.bind(styles);
export var MobileMenu = function MobileMenu(_ref) {
  var _mobileSelectedGroup$;

  var hint = _ref.hint,
      home = _ref.home,
      _ref$navigationFavori = _ref.navigationFavorites,
      navigationFavorites = _ref$navigationFavori === void 0 ? defaultPropObject : _ref$navigationFavori,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
      showSearch = _ref.showSearch,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      Region = _ref.Region,
      language = _ref.language,
      searchValue = _ref.searchValue,
      onChangeSearch = _ref.onChangeSearch,
      isSearch = _ref.isSearch,
      searchLoading = _ref.searchLoading,
      searchPlaceholder = _ref.searchPlaceholder,
      searchNotFoundTitle = _ref.searchNotFoundTitle,
      searchNotFoundSubtitle = _ref.searchNotFoundSubtitle,
      searchNotFound = _ref.searchNotFound,
      _ref$navigationResult = _ref.navigationResult,
      navigationResult = _ref$navigationResult === void 0 ? defaultPropArray : _ref$navigationResult,
      mobileSelectedGroup = _ref.mobileSelectedGroup,
      setMobileSubMenu = _ref.setMobileSubMenu,
      searchResults = _ref.searchResults,
      profileBlock = _ref.profileBlock,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      isShowHeader = _ref.isShowHeader;

  var _useState = useState([0]),
      _useState2 = _slicedToArray(_useState, 2),
      accordionExpandedItems = _useState2[0],
      setAccordionExpandedItems = _useState2[1];

  var breakpoints = useMediaQuery('xs');
  var isMobile = breakpoints.xs;
  var closeAndBackButton = /*#__PURE__*/React.createElement(React.Fragment, null, mobileSelectedGroup ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('back'),
    onClick: function onClick() {
      return setMobileSubMenu && setMobileSubMenu(null);
    }
  }, /*#__PURE__*/React.createElement(ArrowLeft, null)) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClose,
    className: cx('close')
  }, /*#__PURE__*/React.createElement(CloseLinear, null)));
  var logo = /*#__PURE__*/React.createElement(Icon, {
    theme: theme,
    isMobile: isMobile
  });

  var toggleAccordionItem = function toggleAccordionItem(toggledIndex) {
    return setAccordionExpandedItems(accordionExpandedItems.includes(toggledIndex) ? accordionExpandedItems.filter(function (index) {
      return index !== toggledIndex;
    }) : accordionExpandedItems.concat(toggledIndex));
  };

  return /*#__PURE__*/React.createElement("section", {
    className: cx('root', "theme_".concat(theme), {
      with_home: home,
      showSearch: showSearch
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('inner', classes.inner)
  }, !isSearch && isShowHeader && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('head')
  }, closeAndBackButton, logo, /*#__PURE__*/React.createElement("div", {
    className: cx('actions')
  }, Region && /*#__PURE__*/React.createElement(Region, null), profileBlock))), showSearch && /*#__PURE__*/React.createElement("div", {
    className: cx('search')
  }, /*#__PURE__*/React.createElement(Search, {
    onChange: onChangeSearch,
    placeholder: searchPlaceholder,
    size: "small",
    theme: "grey",
    value: searchValue
  })), !isSearch && /*#__PURE__*/React.createElement(Scrollbar, {
    className: cx('scroll')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('categories')
  }, !searchValue && (mobileSelectedGroup ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    level: 3
  }, /*#__PURE__*/React.createElement(Markup, {
    text: mobileSelectedGroup.title
  })), /*#__PURE__*/React.createElement("div", {
    className: cx({
      selected_group: mobileSelectedGroup
    })
  }, (_mobileSelectedGroup$ = mobileSelectedGroup.points) === null || _mobileSelectedGroup$ === void 0 ? void 0 : _mobileSelectedGroup$.map(function (point) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('mobile-selected-group-container-item')
    }, /*#__PURE__*/React.createElement(SearchLink, _extends({}, point, {
      theme: theme,
      onClick: onClose
    })));
  }))) : /*#__PURE__*/React.createElement(Menu, {
    accordionExpandedItems: accordionExpandedItems,
    navigation: navigationResult,
    navigationFavorites: navigationFavorites,
    setSubmenu: setMobileSubMenu,
    theme: theme,
    toggleAccordionItem: toggleAccordionItem,
    onClose: onClose
  })), searchValue && /*#__PURE__*/React.createElement(React.Fragment, null, navigationResult.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SearchSubMenuItems // eslint-disable-next-line react/no-array-index-key
    , {
      key: "submenu-".concat(index),
      group: item,
      onClose: onClose,
      searchValue: searchValue,
      theme: theme
    });
  }), Boolean(navigationResult.length) && /*#__PURE__*/React.createElement("div", {
    className: cx('divider')
  }), searchResults && /*#__PURE__*/React.createElement(SearchResults, {
    items: searchResults,
    searchValue: searchValue
  }), searchLoading && /*#__PURE__*/React.createElement(SearchLoader, null), searchNotFound && /*#__PURE__*/React.createElement("div", {
    className: cx('not_found')
  }, /*#__PURE__*/React.createElement(SearchNotFound, {
    subtitle: searchNotFoundSubtitle,
    title: searchNotFoundTitle,
    showPicture: true
  })))), hint && /*#__PURE__*/React.createElement("div", {
    className: cx('hint')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('hint_title')
  }, /*#__PURE__*/React.createElement(TextBase, {
    size: "m",
    weight: "semibold"
  }, hint.title)), /*#__PURE__*/React.createElement(TextBase, {
    size: "m"
  }, /*#__PURE__*/React.createElement(Link, {
    href: hint.href,
    onClick: hint.onClick
  }, hint.link), hint.text))), home && /*#__PURE__*/React.createElement("a", {
    className: cx('home'),
    href: home.href
  }, /*#__PURE__*/React.createElement(TextBase, null, home.title), /*#__PURE__*/React.createElement(ChevronNormalRight, null))));
};